import { useEffect, useState } from 'react'

/* Styles */
import style from './SchoolRecordForm.module.css'

/* Libraries */
import { useForm } from 'react-hook-form'

/* Apis */
import { adminGetSchoolRecordDataApi } from '../../../api/admin/schoolRecord'
import { getSchoolRecordInfoApi } from '../../../api/schoolRecord'

/* Utils */
import { swalErrorAlert } from '../../../utils/swal/swal'

/* Components */
import HtmlPrintBox from '../../admin/common/HtmlPrintBox';


const SchoolRecordReadForm = ({ schoolRecordId, pdfRef, isAdmin = false }) => {
  /* React Hook Form */
  const { reset, getValues } = useForm()

  /* States */
  const [schoolRecordInfo, setSchoolRecordInfo] = useState(null)

  /* UseEffect */
  useEffect(() => {
    getSchoolRecordInfo(schoolRecordId)
  }, [schoolRecordId])

  useEffect(() => {
    reset(schoolRecordInfo)
  }, [schoolRecordInfo])


  /* Methods */
  const getSchoolRecordInfo = async (schoolRecordId) => {
    if (!schoolRecordId) {
      setSchoolRecordInfo(null)
      return
    }

    try {
      let response;
      if (isAdmin) {
        response = await adminGetSchoolRecordDataApi(schoolRecordId)
      } else {
        response = await getSchoolRecordInfoApi(schoolRecordId)
      }

      if (response.status === 200) {
        const jsonData = response.data?.resData?.json_data ? response.data?.resData?.json_data : null
        setSchoolRecordInfo(jsonData)
      }
      return

    } catch (error) {
      console.log(error);
      setSchoolRecordInfo(null)
      swalErrorAlert('생활기록부 조회 실패', '생활기록부 데이터를 불러오는 도중에 에러가 발생했습니다.')
      return
    }
  }


  return (
    <form id='schoolRecordForm'>
      <div className="mb-3">
        <label htmlFor="title" className="form-label">제목 (Title)</label>
        <div className='pt-3 pb-2 font-weight-bold'>{getValues('title')}</div>
      </div>
      <hr className='divider-row' />

      <div className='py-3'>
        <div className={style.schoolRecordWrap}>

          <div className={style.schoolRecord} ref={pdfRef}>
            <div className={style.topTitleWrap}>
              <h1 className={style.topTitle}>학교생활세부사항기록부(Student Record)</h1>
            </div>

            {/* 1. 수 상 경 력 */}
            <div className={`${style.section} awards`}>
              <h2 className={style.sectionTitle}>1. 수 상 경 력 (Awards and Honors)</h2>

              <div className={style.sectionContent}>
                {/* <AwardsTable data={schoolRecordInfo?.awards} /> */}
                <AwardsInSchoolTable data={schoolRecordInfo?.awardsInSchool} /><br />
                <AwardsOutOfSchoolTable data={schoolRecordInfo?.awardsOutOfSchool} /> <br />
                <AwardsCertificateTable data={schoolRecordInfo?.awardsCertificate} />
              </div>
            </div>

            {/* 2. 창의적 체험활동상황 */}
            <div className={`${style.section} creative`}>
              <h2 className={style.sectionTitle}>2. 창의적 체험활동상황 (Creative Experiential Activities)</h2>

              <div className={style.sectionContent}>
                <CreativeTable dataArr={[schoolRecordInfo?.creative10, schoolRecordInfo?.creative11, schoolRecordInfo?.creative12]} />
                <br /><br />
                <VolunteerTable dataArr={[schoolRecordInfo?.volunteer10, schoolRecordInfo?.volunteer11, schoolRecordInfo?.volunteer12]} />
              </div>
            </div>

            {/* 3. 교과학습발달상황 */}
            <div className={`${style.section} learning`}>
              <h2 className={style.sectionTitle}>3. 교과학습발달상황 (Academic Achievement Record)</h2>

              <div className={style.sectionContent}>
                {/* 10학년 */}
                <LearningTable
                  grade={10}
                  dataArr={{
                    general: [schoolRecordInfo?.learningGeneralGrade10Semester1, schoolRecordInfo?.learningGeneralGrade10Semester2, schoolRecordInfo?.learningGeneralGrade10UnitSum, schoolRecordInfo?.learningGeneralGrade10Detail1, schoolRecordInfo?.learningGeneralGrade10Detail2],
                    // career: [schoolRecordInfo?.learningCareerGrade10Semester1, schoolRecordInfo?.learningCareerGrade10Semester2, schoolRecordInfo?.learningCareerGrade1UnitSum, schoolRecordInfo?.learningCareerGrade10Detail],
                    // artsAndPe: [schoolRecordInfo?.learningArtsAndPeGrade10Semester1, schoolRecordInfo?.learningArtsAndPeGrade10Semester2, schoolRecordInfo?.learningArtsAndPeGrade1UnitSum, schoolRecordInfo?.learningArtsAndPeGrade10Detail],
                  }}
                />
                <br /><br />

                <LearningTable
                  grade={11}
                  dataArr={{
                    general: [schoolRecordInfo?.learningGeneralGrade11Semester1, schoolRecordInfo?.learningGeneralGrade11Semester2, schoolRecordInfo?.learningGeneralGrade11UnitSum, schoolRecordInfo?.learningGeneralGrade11Detail1, schoolRecordInfo?.learningGeneralGrade11Detail2],
                    // career: [schoolRecordInfo?.learningCareerGrade11Semester1, schoolRecordInfo?.learningCareerGrade11Semester2, schoolRecordInfo?.learningCareerGrade11UnitSum, schoolRecordInfo?.learningCareerGrade11Detail],
                    // artsAndPe: [schoolRecordInfo?.learningArtsAndPeGrade12Semester1, schoolRecordInfo?.learningArtsAndPeGrade12Semester2, schoolRecordInfo?.learningArtsAndPeGrade12UnitSum, schoolRecordInfo?.learningArtsAndPeGrade2Detail],
                  }}
                />
                <br /><br />

                <LearningTable
                  grade={12}
                  dataArr={{
                    general: [schoolRecordInfo?.learningGeneralGrade12Semester1, schoolRecordInfo?.learningGeneralGrade12Semester2, schoolRecordInfo?.learningGeneralGrade12UnitSum, schoolRecordInfo?.learningGeneralGrade12Detail1, schoolRecordInfo?.learningGeneralGrade12Detail2],
                    // career: [schoolRecordInfo?.learningCareerGrade3Semester1, schoolRecordInfo?.learningCareerGrade3Semester2, schoolRecordInfo?.learningCareerGrade3UnitSum, schoolRecordInfo?.learningCareerGrade3Detail],
                    // artsAndPe: [schoolRecordInfo?.learningArtsAndPeGrade3Semester1, schoolRecordInfo?.learningArtsAndPeGrade3Semester2, schoolRecordInfo?.learningArtsAndPeGrade3UnitSum, schoolRecordInfo?.learningArtsAndPeGrade3Detail],
                  }}
                />
              </div>
            </div>

            {/* 4. 탐구보고서 작성 상황 */}
            <div className={`${style.section} reading`}>
              <h2 className={style.sectionTitle}>4. 탐구보고서 작성 상황 (Exploratory Activities)</h2>

              <div className={style.sectionContent}>
                <ReadingTable data={schoolRecordInfo?.reading} />
              </div>
            </div>

            {/* 5. 행동특성 및 종합의견 */}
            <div className={`${style.section} behavior`}>
              <h2 className={style.sectionTitle}>5. 행동특성 및 종합의견 (Behavioral Characteristics & Overall Evaluation)</h2>

              <div className={style.sectionContent}>
                <BehaviorTable getValues={getValues} />
              </div>
            </div>

          </div>
        </div>
      </div>
    </form>
  )
}

// const AwardsTable = ({ data }) => {
//   return (
//     <table className={`${style.schoolRecordTable} table table-bordered`}>
//       <colgroup>
//         <col width={"50px"} />
//         <col width={"50px"} />
//         <col width={"auto"} />
//         <col width={"100px"} />
//         <col width={"100px"} />
//         <col width={"140px"} />
//         <col width={"100px"} />
//       </colgroup>
//       <thead>
//         <tr>
//           <th colSpan={2}>
//             학년 / 학기
//             <br />
//             (Grade / Semester)
//           </th>
//           <th>
//             수상명
//             <br />
//             (Awards)
//           </th>
//           <th>
//             등급
//             <br />
//             (Level)
//           </th>
//           <th>
//             수상연월일
//             <br />
//             (Date of Issue)
//           </th>
//           <th>
//             수여기관
//             <br />
//             (Issuing Organization)
//           </th>
//           <th>
//             참가대상
//             <br />
//             (Number of Participants)
//           </th>
//         </tr>
//       </thead>

//       <tbody>
//         {data && data.map((field, index) => {
//           return (
//             <tr key={"awards-" + index}>
//               <td>
//                 <div>{field.grade}</div>
//               </td>
//               <td>
//                 <div>{field.semester}</div>
//               </td>
//               <td>
//                 <div className='text-start'>{field?.name ? field.name : <br />}</div>
//               </td>
//               <td>
//                 <div>{field.rating}</div>
//               </td>
//               <td>
//                 <div>{field.date}</div>
//               </td>
//               <td>
//                 <div>{field.institution}</div>
//               </td>
//               <td>
//                 <div>{field.target}</div>
//               </td>
//             </tr>
//           )
//         })}
//         {!data && (
//           <tr>
//             <td><br /></td>
//             <td></td>
//             <td></td>
//             <td></td>
//             <td></td>
//             <td></td>
//             <td></td>
//           </tr>
//         )}
//       </tbody>
//     </table>
//   )
// }
const AwardsInSchoolTable = ({ data }) => {
  return (
    <table className={`${style.schoolRecordTable} table table-bordered`}>
      <caption className='table-caption'>[1-1. 교내 수상 경력 (&lt;in school&gt; Awards) ]</caption>
      <colgroup>
        <col width={"50px"} />
        <col width={"50px"} />
        <col width={"auto"} />
        <col width={"100px"} />
        <col width={"100px"} />
        <col width={"140px"} />
        <col width={"100px"} />
      </colgroup>
      <thead>
        <tr>
          <th colSpan={2}>
            학년 / 학기
            <br />
            (Grade / Semester)
          </th>
          <th>
            수상명
            <br />
            (Awards)
          </th>
          <th>
            등급
            <br />
            (Level)
          </th>
          <th>
            수상연월일
            <br />
            (Date of Issue)
          </th>
          <th>
            수여기관
            <br />
            (Issuing Organization)
          </th>
          <th>
            참가대상
            <br />
            (Number of Participants)
          </th>
        </tr>
      </thead>

      <tbody>
        {data && data.map((field, index) => {
          return (
            <tr key={"awardsInSchool-" + index}>
              <td>
                <div>{field.grade}</div>
              </td>
              <td>
                <div>{field.semester}</div>
              </td>
              <td>
                <div className='text-start'>{field?.name ? field.name : <br />}</div>
              </td>
              <td>
                <div>{field.rating}</div>
              </td>
              <td>
                <div>{field.date}</div>
              </td>
              <td>
                <div>{field.institution}</div>
              </td>
              <td>
                <div>{field.target}</div>
              </td>
            </tr>
          )
        })}
        {!data && (
          <tr>
            <td><br /></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        )}
      </tbody>
    </table>
  )
}
const AwardsOutOfSchoolTable = ({ data }) => {
  return (
    <table className={`${style.schoolRecordTable} table table-bordered`}>
      <caption className='table-caption'>[1-2. 교외 수상 경력 (&lt;out of school&gt; Awards) ]</caption>
      <colgroup>
        <col width={"50px"} />
        <col width={"50px"} />
        <col width={"auto"} />
        <col width={"100px"} />
        <col width={"100px"} />
        <col width={"140px"} />
        <col width={"100px"} />
      </colgroup>
      <thead>
        <tr>
          <th colSpan={2}>
            학년 / 학기
            <br />
            (Grade / Semester)
          </th>
          <th>
            수상명
            <br />
            (Awards)
          </th>
          <th>
            등급
            <br />
            (Level)
          </th>
          <th>
            수상연월일
            <br />
            (Date of Issue)
          </th>
          <th>
            수여기관
            <br />
            (Issuing Organization)
          </th>
          <th>
            참가대상
            <br />
            (Number of Participants)
          </th>
        </tr>
      </thead>

      <tbody>
        {data && data.map((field, index) => {
          return (
            <tr key={"awardsOutOfSchool-" + index}>
              <td>
                <div>{field.grade}</div>
              </td>
              <td>
                <div>{field.semester}</div>
              </td>
              <td>
                <div className='text-start'>{field?.name ? field.name : <br />}</div>
              </td>
              <td>
                <div>{field.rating}</div>
              </td>
              <td>
                <div>{field.date}</div>
              </td>
              <td>
                <div>{field.institution}</div>
              </td>
              <td>
                <div>{field.target}</div>
              </td>
            </tr>
          )
        })}
        {!data && (
          <tr>
            <td><br /></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        )}
      </tbody>
    </table>
  )
}
const AwardsCertificateTable = ({ data }) => {
  return (
    <table className={`${style.schoolRecordTable} table table-bordered`}>
      <caption className='table-caption'>[1-3. 임명장 (Certificate of Appointment) ]</caption>
      <colgroup>
        <col width={"50px"} />
        <col width={"50px"} />
        <col width={"auto"} />
        <col width={"100px"} />
        <col width={"100px"} />
        <col width={"140px"} />
        <col width={"100px"} />
      </colgroup>
      <thead>
        <tr>
          <th colSpan={2}>
            학년 / 학기
            <br />
            (Grade / Semester)
          </th>
          <th>
            수상명
            <br />
            (Awards)
          </th>
          <th>
            등급
            <br />
            (Level)
          </th>
          <th>
            수상연월일
            <br />
            (Date of Issue)
          </th>
          <th>
            수여기관
            <br />
            (Issuing Organization)
          </th>
          <th>
            참가대상
            <br />
            (Number of Participants)
          </th>
        </tr>
      </thead>

      <tbody>
        {data && data.map((field, index) => {
          return (
            <tr key={"awardsCertificate-" + index}>
              <td>
                <div>{field.grade}</div>
              </td>
              <td>
                <div>{field.semester}</div>
              </td>
              <td>
                <div className='text-start'>{field?.name ? field.name : <br />}</div>
              </td>
              <td>
                <div>{field.rating}</div>
              </td>
              <td>
                <div>{field.date}</div>
              </td>
              <td>
                <div>{field.institution}</div>
              </td>
              <td>
                <div>{field.target}</div>
              </td>
            </tr>
          )
        })}
        {!data && (
          <tr>
            <td><br /></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        )}
      </tbody>
    </table>
  )
}

const CreativeTable = ({ dataArr }) => {
  return (
    <table className={`${style.schoolRecordTable} table table-bordered`}>
      <colgroup>
        <col width={"80px"}></col>
        <col width={"150px"}></col>
        <col width={"80px"}></col>
        <col width={"auto"}></col>
      </colgroup>
      <thead>
        <tr>
          <th rowSpan={2}>학년<br /> (Grade)</th>
          <th colSpan={3}>창 의 적 체 험 활 동 상 황 (Creative Experiential Activities)</th>
        </tr>
        <tr>
          <th>영역<br /> (Category)</th>
          <th>시간<br /> (Hour)</th>
          <th>특기사항<br /> (Comments)</th>
        </tr>
      </thead>
      <CreativeTbody grade={10} data={dataArr[0]} />
      <CreativeTbody grade={11} data={dataArr[1]} />
      <CreativeTbody grade={12} data={dataArr[2]} />
    </table>
  )
}
const CreativeTbody = ({ grade, data }) => {
  return (
    <tbody>
      {data && data.map((field, index) => {
        return (
          <tr key={'creative-' + grade + '-' + index}>
            {index === 0 && <td rowSpan={data.length}>{grade}</td>}
            <td>
              <div>{field.area}</div>
            </td>
            <td>
              <div>{field.time}</div>
            </td>
            <td>
              <div className='text-start'>{field.remarks}</div>
            </td>
          </tr>
        )
      })}
      {!data && (
        <tr>
          <td><br /></td>
          <td></td>
          <td></td>
        </tr>
      )}
    </tbody>
  )
}

const VolunteerTable = ({ dataArr }) => {
  return (
    <table className={`${style.schoolRecordTable} table table-bordered`}>
      <colgroup>
        <col width={"80px"}></col>
        <col width={"145px"}></col>
        <col width={"auto"}></col>
        <col width={"auto"}></col>
        <col width={"80px"}></col>
        <col width={"80px"}></col>
      </colgroup>
      <thead>
        <tr>
          <th rowSpan={2}>
            학년<br />
            (Grade)
          </th>
          <th colSpan={5}>봉 사 활 동 실 적 (Volunteer Activity Record)</th>
        </tr>
        <tr>
          <th className='border-none'>
            일자 또는 기간 <br />
            (Date / Period)
          </th>
          <th className='border-none'>
            장소 또는 주관기관명 <br />
            (Location / Host Organization)
          </th>
          <th className='border-none'>
            활동내용 <br />
            (Activity Details)
          </th>
          <th className='border-none'>
            시간 <br />
            (Hours)
          </th>
          <th className='border-none'>
            누계시간 <br />
            (Total Hours)
          </th>
        </tr>
      </thead>
      <VolunteerTbody grade={10} data={dataArr[0]} />
      <VolunteerTbody grade={11} data={dataArr[1]} />
      <VolunteerTbody grade={12} data={dataArr[2]} />
    </table>
  )
}
const VolunteerTbody = ({ grade, data }) => {
  return (
    <tbody>
      {data && data.map((field, index) => {
        return (
          <tr key={'volunteer-' + grade + '-' + index} className='border-none'>
            {index === 0 && <td rowSpan={data.length + 1}>{grade}</td>}

            <td className='border-none'>
              <div className='text-start'>{field.date}</div>
            </td>
            <td className='border-none'>
              <div className='text-start'>{field.place}</div>
            </td>
            <td className='border-none'>
              <div className='text-start'>{field.content}</div>
            </td>
            <td className='border-none'>
              <div>{field.time}</div>
            </td>
            <td className='border-none'>
              <div>{field.timesum}</div>
            </td>
          </tr>
        )
      })}
      {!data && (
        <tr>
          <td><br /></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      )}
    </tbody>
  )
}

const LearningTable = ({ grade, dataArr }) => {
  return (
    <>
      <GeneralTable grade={grade} data={dataArr['general']} />
    </>
  )
}
const GeneralTable = ({ grade, data }) => {
  return (
    <>
      {/* CompletionTable */}
      <table className={`${style.schoolRecordTable} table table-bordered`} >
        <caption className='table-caption'>[{grade}학년 (Grade {grade})]</caption>
        <thead>
          <tr>
            <th width={"84px"}>
              학기<br />
              (Semester)
            </th>
            <th width={"160px"}>
              교과<br />
              (Subject Area)
            </th>
            <th width={"160px"}>
              과목<br />
              (Subject)
            </th>
            <th width={"70px"}>
              단위수<br />
              (Credits)
            </th>
            <th width={"90px"}>
              성취도<br />
              (Grade)
            </th>
            <th width={"90px"}>
              석차등급<br />
              (Score)
            </th>
            <th width={"90px"}>
              비고<br />
              (Remarks)
            </th>
          </tr>
        </thead>

        {/* 1학기 */}
        <GeneralCompletionTbody grade={grade} semester={1} data={data[0]} />

        {/* 2학기 */}
        <GeneralCompletionTbody grade={grade} semester={2} data={data[1]} />

        {/* 이수단위 합계 */}
        <tbody>
          <tr>
            <td colSpan={3}>이수단위 합계<br /> (Total)</td>
            <td>
              <div>{data[2]}</div>
            </td>
            <td colSpan={2}></td>
            <td></td>
          </tr>
        </tbody>
      </table >
      <br />

      {/* DetailTable */}
      <table className={`${style.schoolRecordTable} table table-bordered`}>
        <thead>
          <tr>
            <th width={"90px"}>
              학기<br />
              (Semester)
            </th>
            <th width={"140px"} >
              과목<br />
              (Subject)
            </th>
            <th width={"100px"} >
              선생님<br />
              (Teacher)
            </th>
            <th width={"auto"}>
              세 부 능 력 및 특 기 사 항<br />
              (Teacher Remarks)
            </th>
          </tr>
        </thead>
        <GeneralDetailTbody grade={grade} semester={1} data={data[3]} />
        <GeneralDetailTbody grade={grade} semester={2} data={data[4]} />
      </table>
    </>
  )
}
const GeneralCompletionTbody = ({ grade, semester, data }) => {
  return (
    <tbody>
      {data && data.map((field, index) => {
        return (
          <tr key={'learning-general' + grade + '-' + semester + '-' + index} className='border-none'>
            {index === 0 && <td rowSpan={data.length + 1}>{semester}</td>}

            <td className='border-right'>
              <div className='text-start'>{field.topSubject}</div>
            </td>
            <td className='border-right'>
              <div className='text-start'>{field.subject}</div>
            </td>
            <td className='border-right'>
              <div>{field.unit}</div>
            </td>
            <td className='border-right'>
              <div>{field.achievement}</div>
            </td>
            <td className='border-right'>
              <div>{field.rating}</div>
            </td>
            <td className='border-right'>
              <div>{field.remarks}</div>
            </td>
          </tr>
        )
      })}
    </tbody>
  )
}
const GeneralDetailTbody = ({ grade, semester, data }) => {
  return (
    <tbody>
      {data && data.map((field, index) => {
        return (
          <tr key={'learning-general-detail-' + grade + '-' + index} className=''>
            {
              index === 0 &&
              <td rowSpan={data.length + 1}>{semester}</td>
            }
            <td>{field.subject}</td>
            <td>{field.teacher}</td>
            <td>
              <HtmlPrintBox value={field.remarks} />
            </td>

            {/* <td className='text-start border-none' colSpan={2}>
              <div>
                {
                  field.subject
                    ? field.subject
                    : ''
                }
                {
                  field.remarks
                    ? ': ' + field.remarks
                    : ' '
                }
                {!field.subject && !field.remarks && <br />}
              </div>
            </td> */}
          </tr>
        )
      })}
      {!data &&
        <tr className='border-none'>
          <td className='border-none'><br /></td>
        </tr>
      }
    </tbody>
  )
}

const ReadingTable = ({ data }) => {
  return (
    <table className={`${style.schoolRecordTable} table table-bordered`}>
      <thead>
        <tr>
          <th width={"60px"}>
            번호<br />
            (No)
          </th>
          <th width={"100px"}>
            학년<br />
            (Grade)
          </th>
          <th width={"auto"}>
            제목<br />
            (Title)
          </th>
        </tr>
      </thead>

      <tbody>
        {data && data.map((field, index) => {
          return (
            <tr key={'reading-' + index}>
              <td>
                <div>{index + 1}</div>
              </td>
              <td>
                <div>{field?.grade ? field?.grade : <br />}</div>
              </td>
              <td>
                <div>{field.title ? field?.title : <br />}</div>
              </td>
            </tr>
          )
        })}

        {!data && (
          <tr>
            <td><br /></td>
            <td></td>
            <td></td>
          </tr>
        )}
      </tbody>
    </table>
  )
}

const BehaviorTable = ({ getValues }) => {
  return (
    <table className={`${style.schoolRecordTable} table table-bordered`}>
      <thead>
        <tr>
          <th width={"80px"}>
            학년<br />
            (Grade)
          </th>
          <th width={"auto"}>
            행 동 특 성 및 종 합 의 견<br />
            (Behavioral Characteristics & Overall Evaluation)
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>10</td>
          <td>
            <div className='text-start'>{getValues('behaviorFirst')}</div>
          </td>
        </tr>
        <tr>
          <td>11</td>
          <td>
            <div className='text-start'>{getValues('behaviorSecond')}</div>
          </td>
        </tr>
        <tr>
          <td>12</td>
          <td>
            <div className='text-start'>{getValues('behaviorThird')}</div>
          </td>
        </tr>
      </tbody>
    </table>
  )
}


export default SchoolRecordReadForm